import { makeStyles } from '@material-ui/core'
import { SIZE, Style, COLOR } from 'constants/styles'

export default makeStyles({
  root: {
    margin: '0 10px 100px',
  },
  paper: {
    backgroundColor: COLOR.CONTENT_BACKGROUND,
  },
  title: Style.configTitle(SIZE.MAIN_TITLE, COLOR.CLEAR),
  subtitle: Style.configTitle(SIZE.SUB_TITLE, COLOR.CLEAR),
})
